import { Grid, IconButton } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { DeleteIcon } from '../../Global/Icons';

export default function TemplatesDataGrid({ rows, fromAdmin, deleteAnswer, onEdit }) {
  const standardColumns = [
    { field: 'title', headerName: 'Title', flex: 1 },
    { field: 'template', headerName: 'Answer', flex: 1 },
    { field: 'hub', headerName: 'Hub' },
    { field: 'raiting', headerName: 'Rate' },
  ];

  const adminColumns = [
    { field: 'views', headerName: 'Views' },
    { field: 'findHelpful', headerName: 'Find helpful marks' },
    {
      field: 'delete',
      headerName: 'Delete',
      renderCell: (row) => (
        <IconButton onClick={() => deleteAnswer(row.row._id)}>
          <DeleteIcon sx={{ color: 'red' }} />
        </IconButton>
      ),
    },
  ];

  const columns = [...standardColumns, ...(fromAdmin ? adminColumns : [])];

  function handleEdit(row) {
    onEdit(row);
  }

  return (
    <Grid item container sx={{ flex: 1, position: 'relative', height: '85%' }}>
      <Grid item container sx={{ position: 'absolute', height: '100%' }}>
        <DataGridPremium
          columns={columns}
          rows={rows}
          getRowId={(row) => row._id}
          onRowClick={(row) => handleEdit(row.row)}
          disableRowSelectionOnClick
        />
      </Grid>
    </Grid>
  );
}
